import React from "react";
import axios from "axios";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { MdOutlineCancel } from "react-icons/md";
import { AiOutlineDelete } from "react-icons/ai";
import { Modal, Button } from "react-bootstrap";
import "./deletePost.scss";

const DeletePost = (props) => {
  // useStates
  const [modalShow, setModalShow] = React.useState(false);

  // Api
  const deletePost = async (originalUrl) => {
    const del_Post = await axios.post("http://localhost:5000/delete-post", {
      originalUrl,
    });

    toast.success("Post Deleted Successfully", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setModalShow(false);

    // window.location.reload();
  };
  return (
    <>
      <div
        className="delete"
        variant="primary"
        onClick={() => setModalShow(true)}
      >
        <AiOutlineDelete />
      </div>

      <Modal
        show={modalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="deletePost"
      >
        <Modal.Body>
          <MdOutlineCancel color="rgba(255, 0, 0, 0.8)" size={50} />
          <div>Are you sure you want to delete this post?</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModalShow(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={props.onHide}
            className="btn-del"
            onClick={() => {
              deletePost(props.originalUrl);
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default DeletePost;
